/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.permissions'},
});

const PermissionsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/widget-permissions"
    title={messages.title}
  />
);

export default PermissionsItem;
